/**
 * Created by Miguel on 23/05/2017
 */
 import { Component, OnInit,   } from '@angular/core';
 import {UserService} from "../../../services/user.service";
 import { AppDataService }  from '../../../services/app-data.service';
 import { CompanyService }  from '../../../services/company.service';
 import { NpcModalComponent }  from '../npc-modal/npc-modal-component';
 import { DomSanitizer,  SafeResourceUrl , SafeHtml } from '@angular/platform-browser';
 import { ItemBean } from '../../../beansts/item.bean';
 import { WalletService }  from '../../../services/wallet.services';

 declare var $ : any;
 declare var Swal: any
 
 @Component({
     selector : 'trade-modal',
     templateUrl:'trade-modal.html',
     providers  : [],  
 })
 export class TradeModalComponent implements OnInit {


  public trader;
  public tokens=[]
  public myoptions=[]
  public mychosen=[]
  public hischosen=[]
  public token=null;

   public list;
   public containerList;
   public userCanEdit=false;
   public ground=false;
   public groundList;
   public groundName='Chão';
   public containerImg='/assets/game-ui/bag/bag.png'
 
   
   public coinsEarned=0;
   public buyerGold=0;
   public tell=false;
   public paint;
   public equipChanged={};
   public vendorName='Vendedor';
   public title='Clique para usar'

   public ctx;
   public canvas;
 
   public recipe;
 
   public voidImage
   public MAXQUANTITY=10;
   public gender='male';
   public skin ='rgb(255, 0, 0,.2)';
   public shirt='rgb(255, 0, 0,.6)';
   public pants='rgb(0, 0, 255,.2)';
   public head='rgb(0, 0, 0,1)'
   public shoes='rgb(0, 0, 0,1)';
   public bodyTypeUrl
   public headTypeUrl
   public chestTypeUrl
   public legsTypeUrl
   public feetTypeUrl
   public isContainer=false;
   public bufferImage;
   public bufferName;
   public avatar;
   public admin=true;
   public allLoaded=false;
 
     public ngOnInit() : any {
       this.list = new Array(25).fill({'name':'vazio',thumbnail:'/assets/avatars/black.png',quantity:0})
       this.containerList = new Array(25).fill({'name':'vazio',thumbnail:'/assets/avatars/black.png',quantity:0})
 
       if (!this._appData.userEventContainer){
         this._companyService.getUserContainerRef().get().then((cdata)=>{
             let clist= new Array(25).fill({'name':'vazio',thumbnail:'/assets/avatars/black.png',quantity:0})
            let i=0;
             cdata.forEach(c=>{
               let item=new ItemBean();
               item.parse(c.data())
               clist[i]=(item)
               i++
             })
             this._appData.userEventContainer=clist;
           })
 
       }
     }
 
 

     public isNumber(n){
      return !isNaN(parseFloat(n)) && !isNaN(n - 0);
    }

 
     public change() {


         

 


     }
     public closeModal(){

     }
     public updateUserImage(){

     }
     public selectToken(token){
       this.token=token;
       if (token=='BmHvLKAGRd2o3WKm2U7u7qaJoAjzqCQfzLyUVrFznmuu'){
         this.myoptions=[{
          name:'livecoin',
          objectId:'BmHvLKAGRd2o3WKm2U7u7qaJoAjzqCQfzLyUVrFznmuu',
          quantity:20
         }]

       }
       else{
        this.myoptions=this._appData.userEventContainer.filter(v=>{
          return v.tokenId==token;
        })
       }
     }
     public reload(){
       
        this.trader=this._appData.friendOnEvent;
        this._appData.friendOnEvent=null;

        
      this._walletService.getTokenBalance('user',this._appData.instagramUser.uid).subscribe(val=>{
        let vet=val.json();
        let lid=0;
        let nfts=[]
        this.tokens=[]
        vet.forEach(element => {
          let address=element.mint_address
          let amount=element.ui_amount
          let recArr=this._appData.eventRecipes.filter((val)=>{
            return val.id==address
          })
          let recipe=recArr[0];
          if (recipe){
            this.tokens.push(recipe)
          }
          else{
            //nft
//            nfts.push(element.mint_address)
          }
        });
      })

     }
     constructor( public _sanitizer: DomSanitizer,public _appData : AppDataService,public _companyService : CompanyService,public _auth : UserService,public _walletService : WalletService) {

     }
 
     



 
 
 



 }


// WEBPACK FOOTER //
// C:/prj/liveplanet-app-site/src/app/components/+gameevent/trade/trade-modal.ts